import { render, staticRenderFns } from "./WalletConnectNotification.vue?vue&type=template&id=a4596d4c&scoped=true&"
import script from "./WalletConnectNotification.vue?vue&type=script&lang=js&"
export * from "./WalletConnectNotification.vue?vue&type=script&lang=js&"
import style0 from "./WalletConnectNotification.vue?vue&type=style&index=0&id=a4596d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4596d4c",
  null
  
)

export default component.exports